/**
 * URL canónica del sitio en producción (sin barra final).
 * En builds locales o staging: define REACT_APP_SITE_URL en .env
 */
export function getSiteOrigin() {
	const fromEnv =
		typeof process !== "undefined" && process.env.REACT_APP_SITE_URL;
	return (fromEnv || "https://guias.viajesmolones.com").replace(/\/$/, "");
}

export function absoluteUrl(pathname = "/") {
	const origin = getSiteOrigin();
	const path = pathname.startsWith("/") ? pathname : `/${pathname}`;
	return `${origin}${path}`;
}
